import Axios from 'axios';
import {getAuthToken} from './auth';
import {base, SystemKey} from '../constants';
import store from '../store';
import router from '../routes';
import qs from 'qs';
export function req(url, options = {}) {
    const defaultOptions = {
        method: 'get',
        url,
        baseURL: base,
        paramsSerializer(params){
            return qs.stringify(params)
        }
    };
    return Axios
        .request({...defaultOptions, ...options})
        .catch(({response}) => {
            const {status} = response;
            if (status === 401) {
                store.commit({
                    type: 'showMessage',
                    message: '登入逾時',
                    msgType: 'warning',
                });
                setTimeout(() => {
                    store.commit('logout');
                }, 1000);
                return;
            }
            //todo 400 error
            // environment should not be used
            if (status === 403) {
                router.push('/403');
                return;
            }
            if (status <= 504 && status >= 500) {
                router.push('/500');
                return;
            }
            if (status >= 404 && status < 422) {
                router.push('/404');
                return;
            }
        });
}

export function reqWithToken(url, options = {}) {
    return req(url, {
        ...options, headers: {
            'authorization': `Bearer ${getAuthToken()}`,
            'systemKey' : SystemKey
        }
    })
}